import { BookModel } from './model';
import { AccountsModel } from './accountModel';

/**
 * Create the models for one booking context (front or admin).
 * Pass the result to <BookAppointment {...context} />.
 */
export const createBookContext = (config) => ({
  config,
  model: new BookModel(config),
  accountModel: new AccountsModel(config)
});
